import api from "@/lib/api";

// CREATE
export const createOffer = async (payload) => {
  const res = await api.post("/offers/create", payload);
  return res.data;
};

// GET ALL
export const getAllOffers = async () => {
  const res = await api.get("/offers/all");
  return res.data;
};

// DELETE
export const deleteOffer = async (offer_id) => {
  const res = await api.post(`/offers/delete/${offer_id}`);
  return res.data;
};

// UPDATE (when backend is ready)
export const updateOffer = async (payload) => {
  const res = await api.post("/offers/update", payload);
  return res.data;
};